<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت پیگیریهای مشتریان</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">پیگیری مشتری ها</h5>
                                <!--<h5 class="text-accent-light" v-if="showReciveDate">(سر رسید تاریخ)</h5>-->
                                <h5 class="text-accent-light" v-if="showArchive">(آرشیو شده)</h5>
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-lightt"
                                            @click="onArchiveClicked()">
                                        <i class="fa fa-eye" v-if="showArchive" title="عدم نمایش آرشیو ها"></i>
                                        <i class="fa fa-eye-slash" v-else title="نمایش آرشیو ها"></i>
                                    </button>
                                    <!--<button class="btn btn-link text-accent-light"-->
                                    <!--@click="onReciveDateClicked()">-->
                                    <!--<i class="fa fa-calendar-check-o" v-if="showReciveDate"-->
                                    <!--title="عدم نمایش سررسیدها"></i>-->
                                    <!--<i class="fa fa-calendar-times-o" v-else title="نمایش سررسیدها"></i>-->
                                    <!--</button>-->

                                    <button class="btn btn-link text-accent-light"
                                            @click="onAddcustomerFollowClicked()"><i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-12 input-group round mb-3" v-if="!showArchive">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از نام یا نام خانوادگی یا شماره موبایل یا محصول را وارد کنید">
                            </div>
                            <!--///////// FILTERS  /////////////////-->
                            <div class="col-lg-6 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">فیلتر بر اساس بازاریاب</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="users"
                                               :mode="'create'"
                                               :selected-val="selectedbazaryab"
                                               :header="{multiple: false, label: 'fullName'}"
                                               aria-placeholder="بازاریاب"
                                               @onChange="onbazaryabChangeFilter"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">فیلتر بر اساس محصول</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="products"
                                               :mode="'create'"
                                               :selected-val="selectedproduct"
                                               :header="{multiple: false, label: 'name'}"
                                               aria-placeholder="محصول"
                                               @onChange="onproductChangeFilter"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">فیلتر بر اساس وضعیت پیگیری</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="enfollowStatus"
                                               :mode="'create'"
                                               :header="{multiple: false, label: 'title'}"
                                               aria-placeholder="وضعیت پیگیری"
                                               @onChange="onfollowStatusChangeFilter"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-2">
                                <div class="input-group round">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">فیلتر بر اساس مشتری</span>
                                    </div>
                                    <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                               ref="evidence"
                                               :data="customers"
                                               :mode="'create'"
                                               :selected-val="selectedcustomer"
                                               :header="{multiple: false, label: 'fullName'}"
                                               aria-placeholder="مشتری"
                                               @onChange="oncustomerChangeFilter"></vs-select>
                                </div>
                            </div>
                            <!--///////// FILTERS  /////////////////-->


                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="mycustomerFollow.length===0">
                                        <p class="text-center mt-3">هیچ پیگیریی ثبت نشده است. برای ثبت روی دکمه + کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>تاریخ پیگیری</th>
                                                <th>نام مشتری</th>
                                                <th>نام محصول</th>
                                                <th>بازاریاب</th>
                                                <th>وضعیت پیگیری</th>
                                                <th>تاریخ پیگیری بعدی</th>
                                                <!--<th v-if="accountPanel">پرداختها</th>-->
                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in mycustomerFollow">

                                                <td class="text-nowrap">{{it.fstartDate}}</td>
                                                <td class="text-nowrap">{{it.customer.fullName}}</td>
                                                <td class="text-nowrap">{{it.product.name}}</td>
                                                <td class="text-nowrap">{{it.follower === null || it.follower ===
                                                    undefined ? '' : it.follower.fullName}}
                                                </td>
                                                <td class="text-nowrap">{{it.statusName}}
                                                </td>
                                                <td class="text-nowrap">{{it.fendDate}}</td>
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editItem(it)"
                                                        title="ویرایش آیتم"></i>
                                                    | <i class="fa fa-trash-o px-3 clickable"
                                                         style="font-size: larger"
                                                         @click="deleteItem(it)"
                                                         title="حذف آیتم"></i>
                                                </td>

                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="customerFollowMode === 'create'">ثبت پیگیری</h1>
                        <h1 v-else> ویرایش پیگیری</h1>
                    </div>
                    <h4 class="text-center" v-if="customerFollowMode === 'create'"> مشتری جدید</h4>

                    <div class="row mt-2" v-if="customerFollowMode === 'create'">
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام مشتری</span>
                                </div>
                                <input class="form-control" v-model="customerModel.name">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام خانوادگی مشتری</span>
                                </div>
                                <input class="form-control" v-model="customerModel.family">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">کد مشتری</span>
                                </div>
                                <input class="form-control" v-model="customerModel.fatherName">
                            </div>
                        </div>
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">موبایل</span>
                                </div>
                                <input class="form-control" v-model="customerModel.mobile">
                            </div>
                        </div>
                        <div class="col-lg-6 offset-lg-3 text-center">
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="newCustomer" v-if="customerFollowMode==='create'">ثبت مشتری جدید
                            </button>
                        </div>
                    </div>
                    <hr class="w-100"/>
                    <div class="row w-100 p-5" v-if="customerFollowMode === 'create'">
                        <h4 class="col-12 text-center">انتخاب مشتری</h4>
                        <div class="col-12 input-group round mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text">جستجو</span>
                            </div>
                            <input class="form-control" v-model="searchcustomer" @input="searchingcustomer()"
                                   placeholder="حداقل 2 کاراکتر از نام یا نام خانوادگی یا شماره موبایل را وارد کنید">
                        </div>
                        <div class="col-12 overflow-auto" style="max-height: 12rem;">
                            <table class="table table-hover table-striped ">
                                <thead>
                                <tr>
                                    <th>نام مشتری</th>
                                    <th>کد مشتری</th>
                                    <th>موبایل</th>
                                    <th>انتخاب</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="it in customers">

                                    <td class="clickable" @click="selectItem(it)">{{it.fullName}}</td>
                                    <td>{{it.fatherName}}</td>
                                    <td>{{it.mobile}}</td>
                                    <td class="text-center"><i class="fa fa-hand-o-up px-3 clickable"
                                                               style="font-size: larger"
                                                               @click="selectItem(it)"
                                                               title="انتخاب آیتم"></i>
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                    <hr/>
                    <h4 class="text-center"> مشتری انتخاب شده</h4>
                    <div class="row w-100 mt-3">
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام مشتری</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="customerName">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">کد مشتری</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="customerFather">
                            </div>
                        </div>
                        <div class="col-lg-4 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">موبایل</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="customerMobile">
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div class="row mt-3">
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">محصول</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="products"
                                           :mode="'create'"
                                           :selected-val="selectedproduct"
                                           :header="{multiple: false, label: 'name'}"
                                           aria-placeholder="محصول"
                                           @onChange="onproductChange"></vs-select>
                            </div>
                        </div>

                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ پیگیری</span>
                                </div>
                                <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateDatePicked"
                                             :auto-submit="true"
                                             ref=" " style="flex: 1">
                                    <slot>
                                        <input v-model="newstartDate"
                                               class="form-control date-input flex-grow-1" readonly="true"
                                               @click="toggleCreateDatePicker">
                                    </slot>
                                </date-picker>
                            </div>
                        </div>
                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">بازاریاب</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="users"
                                           :mode="'create'"
                                           :selected-val="selectedbazaryab"
                                           :header="{multiple: false, label: 'fullName'}"
                                           aria-placeholder="بازاریاب"
                                           @onChange="onbazaryabChange"></vs-select>
                            </div>
                        </div>

                        <div class="col-lg-3 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">وضعیت پیگری</span>
                                </div>
                                <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                           ref="evidence"
                                           :data="enfollowStatus"
                                           :mode="'create'"
                                           :selected-val="followStatus"
                                           :header="{multiple: false, label: 'title'}"
                                           aria-placeholder="وضعیت پیگیری"
                                           @onChange="onfollowStatusChange"></vs-select>
                            </div>
                        </div>

                        <div class="col-lg-3 mb-2" v-if="nextFollow">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ پیگیری بعدی</span>
                                </div>
                                <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateendDatePicked"
                                             :auto-submit="true"
                                             ref="endDate" style="flex: 1">
                                    <slot>
                                        <input v-model="newendDate"
                                               class="form-control date-input flex-grow-1" readonly="true"
                                               @click="toggleCreateendDatePicker">
                                    </slot>
                                </date-picker>
                            </div>
                        </div>


                        <div class="col-lg-12 mb-4">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات و نتیجه پیگیری</span>
                                </div>
                                <input class="form-control" v-model="customerFollowModel.description">
                            </div>
                        </div>


                        <div class="col-lg-6 offset-lg-3 text-center">
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="updatecustomerFollow" v-if="customerFollowMode=='edit'">ویرایش پیگیری
                            </button>
                            <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                    @click="createcustomerFollow" v-else>ثبت پیگیری
                            </button>
                            <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                    @click="cancelcustomerFollow">انصراف
                            </button>
                        </div>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "customerFollow",
        components: {VsSelect, DatePicker},
        data() {
            return {

                isLoading: false,
                mycustomerFollow: [],

                customerFollowMode: "",
                customerFollowModel: {
                    id: 0,
                    customerId: 0,
                    productId: 0,

                    date: "",
                    nextDate: "",

                    status: 0,
                    description: "",
                    followerId: 0,
                },
                newstartDate: "",
                newendDate: "",
                search: "",
                customers: [],
                customerName: "",
                customerFather: "",
                customerMobile: "",
                customerId: 0,
                searchcustomer: "",
                showArchive: false,
                showReciveDate: false,
                isSending: false,
                accountPanel: false,
                nextFollow: false,
                selectedbazaryab: {},
                selectedmoaref: {},
                users: [],
                products: [],
                selectedproduct: {},
                selectedcustomer: {},
                followStatus: {},
                enfollowStatus: [],
                customerModel: {
                    id: 0,
                    family: "",
                    name: "",
                    fullName: "",
                    mobile: "",
                    fatherName: "",
                    address: "",

                },
            }
        },
        mounted() {
            this.accountPanel = this.userId = Constants.ACCOUNTING_PANEL;
            this.getUsers();
            this.getenfollowStatus();
            this.getproducts();
            this.getcustomers();
            console.log(this.$route.params.param)
            if (this.$route.params.param === 'true') {
                this.onReciveDateClicked();
            } else {
                this.getMycustomerFollow();
            }
        },
        methods: {
            getenfollowStatus() {
                new BaseService("enum", "/GetEnFollowStatus").getList().then(response => {
                    this.enfollowStatus = response.data;
                    // for (let it of this.devices) {
                    //     it.title = it.deviceName + " کد:" + it.deviceCode;
                    // }
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getUsers() {
                new BaseService("user", "/GetUser").getList().then(response => {
                    this.users = response.data;
                    // for (let it of this.devices) {
                    //     it.title = it.deviceName + " کد:" + it.deviceCode;
                    // }
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getproducts() {
                new BaseService("product", "/Getproduct").getList().then(response => {
                    this.products = response.data;
                    // for (let it of this.devices) {
                    //     it.title = it.deviceName + " کد:" + it.deviceCode;
                    // }
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },


            onArchiveClicked() {
                if (this.showArchive) {
                    this.showArchive = false;
                    this.getMycustomerFollow();
                } else {
                    this.showArchive = true;
                    new BaseService("customerFollow", "/GetArchivecustomerFollow").getList().then(response => {
                        this.mycustomerFollow = response.data;
                        for (let it of this.mycustomerFollow) {
                            it.fstartDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.fendDate = it.nextDate !== null ? Moment(this.gregorianToJalali(it.nextDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY') : "";
                            it.oldFollowDesc = it.oldFollow !== null ? it.oldFollow.description : "";
                            for (let stat of this.enfollowStatus) {
                                if (stat.value === it.status) {
                                    it.statusName = stat.title;
                                }
                            }
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            onReciveDateClicked() {
                console.log(this.showReciveDate);
                if (this.showReciveDate === true) {
                    this.showReciveDate = false;
                    this.getMycustomerFollow();
                } else {
                    this.showReciveDate = true;

                    new BaseService("customerFollow", "/GetReciveDatecustomerFollow").getList().then(response => {
                        this.mycustomerFollow = response.data;
                        for (let it of this.mycustomerFollow) {
                            it.fstartDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.fendDate = it.nextDate !== null ? Moment(this.gregorianToJalali(it.nextDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY') : "";
                            it.oldFollowDesc = it.oldFollow !== null ? it.oldFollow.description : "";
                            for (let stat of this.enfollowStatus) {
                                if (stat.value === it.status) {
                                    it.statusName = stat.title;
                                }
                            }
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },

            getcustomers() {
                new BaseService("customer", "/Getcustomer").getList().then(response => {
                    this.customers = response.data;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            onAddcustomerFollowClicked() {
                this.customerFollowModel = {
                    id: 0,
                    customerId: 0,
                    productId: 0,

                    date: "",
                    nextDate: "",

                    status: 0,
                    description: "",
                    followerId: 0,
                };
                this.customerName = "";
                this.customerFather = "";
                this.customerMobile = "";
                this.customerId = 0;
                this.newstartDate="";
                this.newendDate="";
                this.followStatus={};
                this.selectedbazaryab={};
                this.selectedproduct={};

                this.getcustomers();
                this.customerFollowMode = "create";
                this.$refs.insertModal.showModal();
            },

            getMycustomerFollow() {
                // console.log("chara.....")
                this.showReciveDate = false;
                this.showArchive = false;
                new BaseService("customerFollow", "/GetcustomerFollow").getList().then(response => {
                    this.mycustomerFollow = response.data;
                    for (let it of this.mycustomerFollow) {
                        it.fstartDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                        it.fendDate = it.nextDate !== null ? Moment(this.gregorianToJalali(it.nextDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY') : "";
                        it.oldFollowDesc = it.oldFollow !== null ? it.oldFollow.description : "";
                        for (let stat of this.enfollowStatus) {
                            if (stat.value === it.status) {
                                it.statusName = stat.title;
                                break;
                            }
                        }
                    }
                    this.isLoading = true;
                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            editItem(item) {
                this.customerFollowModel = item;
                this.customerFollowMode = "edit";
                if (item.date != null) {
                    this.newstartDate = Moment(this.gregorianToJalali(item.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                if (item.nextDate != null) {
                    this.newendDate = Moment(this.gregorianToJalali(item.nextDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                for (let i of this.products) {
                    if (i.id === item.productId) {
                        this.selectedproduct = i;
                    }
                }
                for (let i of this.users) {
                    if (i.id === item.followerId) {
                        this.selectedbazaryab = i;
                    }
                }
                for (let i of this.enfollowStatus) {
                    if (i.value === item.status) {
                        this.followStatus = i;
                    }
                }
                this.customerName = item.customer.fullName;
                this.customerFather = item.customer.fatherName;
                this.customerMobile = item.customer.mobile;
                this.$refs.insertModal.showModal();
            },
            deleteItem(item) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("customerFollow", "DeletecustomerFollow").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        this.getMycustomerFollow();
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                    })
                }
            },

            updatecustomerFollow() {
                this.isSending = true;
                new BaseService("customerFollow", "/UpdatecustomerFollow").update(this.customerFollowModel).then(response => {
                    this.$noty.success("پیگیری با موفقیت ویرایش شد");
                    this.isSending = false;
                    this.$refs.insertModal.hideModal();
                    this.getMycustomerFollow();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMycustomerFollow();
                });

            },
            createcustomerFollow() {
                this.isSending = true;
                if (this.customerId == 0) {
                    Utils.handleErrorWithNotification("یک مشتری انتخاب کنید", this.$noty);
                    this.isSending = false;
                } else if (this.customerFollowModel.productId == 0) {
                    Utils.handleErrorWithNotification("یک محصول انتخاب کنید", this.$noty);
                    this.isSending = false;
                } else if (this.customerFollowModel.followerId == 0) {
                    Utils.handleErrorWithNotification("بازاریاب را انتخاب کنید", this.$noty);
                    this.isSending = false;
                } else {
                    this.customerFollowModel.customerId = this.customerId;
                    new BaseService("customerFollow", "/CreatecustomerFollow").create(this.customerFollowModel).then(response => {
                        this.$noty.success("پیگیری با موفقیت ثبت شد");
                        this.isSending = false;
                        this.$refs.insertModal.hideModal();
                        this.getMycustomerFollow();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                        this.getMycustomerFollow();
                    });
                }
            },
            cancelcustomerFollow() {
                this.$refs.insertModal.hideModal();
                this.getMycustomerFollow();
            },
            onCreateDatePicked(val) {
                this.newstartDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.customerFollowModel.date = this.jalaliToGregorian(val);
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
            },
            toggleCreateDatePicker() {
                this.$refs.startDate.togglePicker();
            },
            onCreateendDatePicked(val) {
                this.newendDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.customerFollowModel.nextDate = this.jalaliToGregorian(val);
                /* let startDate = this.startPersianDate.split("/");
                 console.log(startDate);*/
            },
            toggleCreateendDatePicker() {
                this.$refs.endDate.togglePicker();
            },
            searching() {
                if (this.search.length > 2) {
                    this.isLoading = false;
                    new BaseService("customerFollow", `/SearchcustomerFollow/${this.search}`).getList().then(response => {
                        this.mycustomerFollow = response.data;
                        for (let it of this.mycustomerFollow) {
                            it.fstartDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.fendDate = it.nextDate !== null ? Moment(this.gregorianToJalali(it.nextDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY') : "";
                            it.oldFollowDesc = it.oldFollow !== null ? it.oldFollow.description : "";
                            for (let stat of this.enfollowStatus) {
                                if (stat.value === it.status) {
                                    it.statusName = stat.title;
                                    break;
                                }
                            }
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getMycustomerFollow();
                }
            },
            searchingcustomer() {
                if (this.searchcustomer.length > 2) {
                    new BaseService("customer", `/Searchcustomer/${this.searchcustomer}`).getList().then(response => {
                        this.customers = response.data;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getcustomers();
                }
            },
            selectItem(it) {
                this.customerName = it.fullName;
                this.customerFather = it.fatherName;
                this.customerMobile = it.mobile;
                this.customerId = it.id;

            },
            seeItem(it) {
                this.$router.push({
                    name: 'payments',
                    params: {
                        search: it.name
                    }
                });
            },
            seeRecItem(it) {
                this.$router.push({
                    name: 'recipts',
                    params: {
                        search: it.customer.fullName
                    }
                });
            },
            thousandSeprator(a) {
                let amount = this.customerFollowModel.price;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    this.customerFollowModel.showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    this.customerFollowModel.showprice = amount;
                }
            },
            onEndContractChange(e) {
                const m = {
                    contractId: this.customerFollowModel.id,
                    ending: e.value
                };
                new BaseService("customerFollow", '/EndcustomerFollow').update(m).then(response => {
                    if (e.value) {
                        this.$noty.success("پیگیری با موفقیت آرشیو شد و دیگر نشان داده نمیشود");

                    } else {
                        this.$noty.success("پیگیری با موفقیت بازیابی شد و نشان داده میشود");
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                this.customerFollowModel.endConract = e.value;

            },

            onbazaryabChange(val) {

                if (val && val.id) {
                    this.customerFollowModel.followerId = val.id;
                    this.selectedbazaryab = val;
                }
            },
            onfollowStatusChange(val) {
                if (val && val.value) {
                    this.customerFollowModel.status = val.value;
                    this.followStatus = val;
                    if (val.value === 2) {
                        this.nextFollow = true;
                    } else {
                        this.nextFollow = false;
                    }
                }
            },
            onproductChange(val) {
                if (val && val.id) {
                    this.customerFollowModel.productId = val.id;
                    this.selectedproduct = val;
                }
            },

            onbazaryabChangeFilter(val) {

                if (val && val.id) {
                    new BaseService("customerFollow", `/GetCustomerFollowByFollower/${val.id}`).getList().then(response => {
                        this.mycustomerFollow = response.data;
                        for (let it of this.mycustomerFollow) {
                            it.fstartDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.fendDate = it.nextDate !== null ? Moment(this.gregorianToJalali(it.nextDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY') : "";
                            it.oldFollowDesc = it.oldFollow !== null ? it.oldFollow.description : "";
                            for (let stat of this.enfollowStatus) {
                                if (stat.value === it.status) {
                                    it.statusName = stat.title;
                                    break;
                                }
                            }
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        console.log(error)
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    if (this.showReciveDate === false) {
                        this.getMycustomerFollow();
                    }
                }
            },
            onfollowStatusChangeFilter(val) {
                if (val && val.value) {
                    new BaseService("customerFollow", `/GetCustomerFollowBystatus/${val.value}`).getList().then(response => {
                        this.mycustomerFollow = response.data;
                        for (let it of this.mycustomerFollow) {
                            it.fstartDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.fendDate = it.nextDate !== null ? Moment(this.gregorianToJalali(it.nextDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY') : "";
                            it.oldFollowDesc = it.oldFollow !== null ? it.oldFollow.description : "";
                            for (let stat of this.enfollowStatus) {
                                if (stat.value === it.status) {
                                    it.statusName = stat.title;
                                    break;
                                }
                            }
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        console.log(error)
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    if (this.showReciveDate === false) {
                        this.getMycustomerFollow();
                    }
                }
            },
            onproductChangeFilter(val) {
                if (val && val.id) {
                    new BaseService("customerFollow", `/GetCustomerFollowByProduct/${val.id}`).getList().then(response => {
                        this.mycustomerFollow = response.data;
                        for (let it of this.mycustomerFollow) {
                            it.fstartDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.fendDate = it.nextDate !== null ? Moment(this.gregorianToJalali(it.nextDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY') : "";
                            it.oldFollowDesc = it.oldFollow !== null ? it.oldFollow.description : "";
                            for (let stat of this.enfollowStatus) {
                                if (stat.value === it.status) {
                                    it.statusName = stat.title;
                                    break;
                                }
                            }
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        console.log(error)
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    if (this.showReciveDate === false) {
                        this.getMycustomerFollow();
                    }
                }
            },
            oncustomerChangeFilter(val) {
                if (val && val.id) {
                    new BaseService("customerFollow", `/GetCustomerFollowByCustomer/${val.id}`).getList().then(response => {
                        this.mycustomerFollow = response.data;
                        for (let it of this.mycustomerFollow) {
                            it.fstartDate = Moment(this.gregorianToJalali(it.date), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                            it.fendDate = it.nextDate !== null ? Moment(this.gregorianToJalali(it.nextDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY') : "";
                            it.oldFollowDesc = it.oldFollow !== null ? it.oldFollow.description : "";
                            for (let stat of this.enfollowStatus) {
                                if (stat.value === it.status) {
                                    it.statusName = stat.title;
                                    break;
                                }
                            }
                        }
                        this.isLoading = true;
                    }).catch(error => {
                        console.log(error)
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    if (this.showReciveDate === false) {
                        this.getMycustomerFollow();
                    }
                }
            },
            newCustomer() {
                this.isSending = true;
                if (this.customerModel.name === "") {
                    Utils.handleErrorWithNotification("نام مشتری را وارد کنید", this.$noty);
                    this.isSending = false;
                } else if (this.customerModel.mobile === "") {
                    Utils.handleErrorWithNotification("شماره موبایل مشتری را وارد کنید", this.$noty);
                    this.isSending = false;
                } else {
                    new BaseService("customer", "/Createcustomer").create(this.customerModel).then(response => {
                        this.$noty.success("مشتری با موفقیت ثبت شد");
                        this.isSending = false;
                        this.getcustomers();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.getcustomers();
                    });
                    this.customerModel = {
                        id: 0,
                        family: "",
                        name: "",
                        fullName: "",
                        mobile: "",
                        fatherName: "",
                        address: "",
                    };
                }
            },

        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>